// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"4d8016f3","268":"600c2baf","448":"e0b9e943","489":"fbffb788","506":"8edd3596","678":"d0834bba","875":"570848ee"}[chunkId] + ".chunk.css";
};